export default __webpack_public_path__ + "static/media/Zeus_Desktop.fa627b88.mp4";